import { Component, Inject } from '@angular/core';
import { helper } from 'src/environments/helper';
import { ICerere } from '../../../cereri.interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CereriService } from '../../../cereri.service';
import { CommonService } from 'src/app/services/common.service';
import { NotificationService } from 'src/app/services/notification.service';
import Swal from 'sweetalert2';
import { finalize } from 'rxjs';
import { countriesList, ICountryOption } from 'src/app/shared/countries-list';

import { PhoneNumberUtil } from 'google-libphonenumber'
const phoneNumberUtil = PhoneNumberUtil.getInstance();

@Component({
    selector: 'app-edit-subsemnat',
    templateUrl: './edit-subsemnat.component.html',
    styleUrls: ['./edit-subsemnat.component.scss']
})
export class EditSubsemnatComponent {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;

    isLoading = false;

    cerereData: ICerere | null = null;

    // phone
    optionRom: ICountryOption = {
        name: 'Romania',
        flag: '🇷🇴',
        code: 'RO',
        dial_code: '+40',
    };

    currentOption = this.optionRom;
    options: ICountryOption[] = countriesList;

    changeCountry(option: ICountryOption) {
        this.currentOption = option;
    }

    form: FormGroup = new FormGroup({
        numeComplet: new FormControl('', [Validators.required, this.numeCompletValidator]),
        cnp: new FormControl('', [Validators.pattern('[0-9]{13}')]),
        telefon: new FormControl('', [Validators.required, Validators.pattern('[0-9]{9,10}')]),
        email: new FormControl('', [Validators.required, Validators.email]),
        observatii: new FormControl('', [Validators.maxLength(500)]),
    });

    // Validator pentru nume complet (minim 2 cuvinte)
    numeCompletValidator(control: FormControl): { [key: string]: boolean } | null {
        if (!control.value) return null;
        const parts = control.value.trim().split(/\s+/);
        if (parts.length < 2) {
            return { 'minWords': true };
        }
        return null;
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            cerereData: ICerere,
        },
        private dialogRef: MatDialogRef<EditSubsemnatComponent>,
        private cereriService: CereriService,
        private notificationService: NotificationService,
    ) {
        this.cerereData = data.cerereData;
    }

    ngOnInit() {
        if (this.cerereData) {
            // Combinăm prenume + nume în numeComplet (prenume primul, nume ultimul)
            const numeComplet = [
                this.cerereData.cetatean.prenume,
                this.cerereData.cetatean.nume
            ].filter(Boolean).join(' ').trim();

            this.form.controls['numeComplet'].patchValue(numeComplet);
            this.form.controls['cnp'].patchValue(this.cerereData.cetatean.cnp);
            this.form.controls['telefon'].patchValue(this.cerereData.cetatean.telefon);
            this.form.controls['email'].patchValue(this.cerereData.cetatean.email);
            this.form.controls['observatii'].patchValue(this.cerereData.cetatean.observatii || '');

            if (this.cerereData.cetatean.iso_code) {
                const countryOption = countriesList.find(
                    (c: any) => c.code.toLowerCase() == this.cerereData?.cetatean.iso_code.toLowerCase()
                );
                this.currentOption = countryOption ? countryOption : this.optionRom;
            }
        }
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Vă rugăm să confirmați acest proces!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.updateInfo();
            }
        });
    }

    updateInfo() {
        this.isLoading = true;

        let phone;

        const telephoneNoInput = this.currentOption.dial_code + this.form.value.telefon;

        const phoneNo = phoneNumberUtil.parseAndKeepRawInput(telephoneNoInput);
        let regionCodeLower = '';
        let nationalNumberString = '';

        if (phoneNo) {
            const regionCode = phoneNumberUtil.getRegionCodeForNumber(phoneNo);
            if (regionCode) {
                regionCodeLower = (regionCode as string).toLowerCase();
            }

            const nationalNumber = phoneNo.getNationalNumber();
            if (nationalNumber) {
                nationalNumberString = nationalNumber.toString();
            }
        }

        phone = {
            dialCode: '',
            internationalNumber: telephoneNoInput,
            isoCode: regionCodeLower,
            nationalNumber: nationalNumberString,
        };

        phone.dialCode = telephoneNoInput.replace(phone.nationalNumber, '');
        phone.nationalNumber = phone.isoCode == 'ro' ? '0' + phone.nationalNumber : phone.nationalNumber;

        // Split numeComplet în nume și prenume (ultimul cuvânt = nume, restul = prenume)
        const numeComplet = this.form.value.numeComplet.trim();
        const nameParts = numeComplet.split(/\s+/);
        const nume = nameParts.pop(); // ultimul cuvânt
        const prenume = nameParts.join(' '); // restul cuvintelor

        const payload = {
            nume: nume,
            prenume: prenume,
            cnp: this.form.value.cnp,
            telefon: this.form.value.telefon,
            email: this.form.value.email,
            observatii: this.form.value.observatii || null,
            phone: phone,
        }

        this.cereriService
            .updateCetatean(this.cerereData!.id, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    Swal.fire({
                        title: helper.dialogConfig.headers.success,
                        text: 'Datele de contact au fost actualizate cu succes',
                        icon: 'success',
                        confirmButtonText: this.helper.dialogConfig.buttonLabels.close,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.dialogRef.close({ success: true });
                        }
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
